import React from 'react';
import { useSelector } from 'react-redux';
import { TruncatedText } from 'ui-components/components/truncated-text';
import style from '../../../../../components/batches/batch-components.module.less';
import Global from '../../../../../store/global-selectors';

const BatchNoteColumn = ({ fulfillmentPlanSetId }) => {
  const fulfillmentPlanSet = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetById(state, {
      fulfillmentPlanSetId,
    }),
  );
  const { note } = fulfillmentPlanSet ?? {};

  return (
    <div className={style['batch-note-column']}>
      <TruncatedText value={note} />
    </div>
  );
};

export default {
  id: 'batch-note',
  messageDescriptorKey: 'columnName',
  width: 200,
  nonsortable: true,
  render: ({ fulfillmentPlanSetId }) => <BatchNoteColumn fulfillmentPlanSetId={fulfillmentPlanSetId} />,
};
